import { Container, type Texture } from 'pixi.js';
import { SideLights, type SideLightsMode } from '../../widgets/road/SideLights';
import type { SceneComponent, SceneLayoutContext } from '../SceneComponent';

/** The side lights on the slot frame (Royal Road). Hidden until the host
 *  gives it a Ready state. */
export class SideLightsComponent extends Container implements SceneComponent {
  private readonly lights: SideLights;

  constructor(count = 10, bezelTexture?: () => Texture | null) {
    super();
    this.lights = new SideLights(count, bezelTexture);
    this.addChild(this.lights);
    this.visible = false;
  }

  layout(ctx: SceneLayoutContext): void {
    if (ctx.machineLeft === undefined || ctx.machineRight === undefined) return;
    this.lights.layout(ctx.machineLeft, ctx.machineRight, ctx.machineTop, ctx.machineBottom, ctx.frameRing || 12);
  }

  /** Show the Ready meter: whole lights lit and how far the next has
   *  filled. Null hides the lights. */
  setReady(state: { lit: number; next: number } | null): void {
    this.visible = state !== null;
    if (state) this.lights.setReady(state.lit, state.next);
  }

  setMode(mode: SideLightsMode): void {
    this.lights.setMode(mode);
  }

  tick(deltaMs: number): void {
    if (this.visible) this.lights.tick(deltaMs);
  }
}
